import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createToneOfVoice, updateToneOfVoice, deleteToneOfVoice } from '../../api/toneOfVoicesApi';

import { toneOfVoicesKeys } from './keys';

export function useCreateToneOfVoice() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (toneData) => createToneOfVoice(toneData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: toneOfVoicesKeys.all });
		},
	});
}

export function useUpdateToneOfVoice() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ id, updates }) => updateToneOfVoice(id, updates),
		onMutate: async ({ id, updates }) => {
			await queryClient.cancelQueries({ queryKey: toneOfVoicesKeys.list() });

			const previousTones = queryClient.getQueryData(toneOfVoicesKeys.list());

			queryClient.setQueryData(toneOfVoicesKeys.list(), (old) => {
				if (!old) return old;
				return old.map((tone) => (tone.id === id ? { ...tone, ...updates } : tone));
			});

			return { previousTones };
		},
		onError: (err, variables, context) => {
			if (context?.previousTones) {
				queryClient.setQueryData(toneOfVoicesKeys.list(), context.previousTones);
			}
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: toneOfVoicesKeys.all });
		},
	});
}

export function useDeleteToneOfVoice() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id) => deleteToneOfVoice(id),
		onMutate: async (id) => {
			await queryClient.cancelQueries({ queryKey: toneOfVoicesKeys.list() });

			const previousTones = queryClient.getQueryData(toneOfVoicesKeys.list());

			queryClient.setQueryData(toneOfVoicesKeys.list(), (old) => {
				if (!old) return old;
				return old.filter((tone) => tone.id !== id);
			});

			return { previousTones };
		},
		onError: (err, id, context) => {
			if (context?.previousTones) {
				queryClient.setQueryData(toneOfVoicesKeys.list(), context.previousTones);
			}
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: toneOfVoicesKeys.all });
		},
	});
}
